/* eslint-disable react/jsx-props-no-spreading */
import PropTypes from 'prop-types';
import React, { useEffect, useRef } from 'react';

import * as AppPropTypes from '../../lib/PropTypes';
import { getComponentFromName } from '../../lib/utils';

import { useItemRefs } from '../../contexts/ItemRefContext';
import * as CardComponents from './index';

const propTypes = {
    item: AppPropTypes.listItem,
    type: PropTypes.string,
    component: PropTypes.elementType,
    components: AppPropTypes.components,
    withRef: PropTypes.bool,
    className: PropTypes.string,
};

const defaultProps = {
    item: null,
    type: null,
    component: null,
    components: null,
    withRef: true,
    className: null,
};

const Card = ({ item, type, component, components, withRef, className, ...props }) => {
    const ref = useRef();
    const { registerRef, unregisterRef, currentItem } = useItemRefs();
    const { id: selectedId, type: selectedType } = currentItem || {};
    const { id = null, type: itemType = null } = item || {};
    const selected = selectedId === id && selectedType === itemType;

    useEffect(() => {
        if (ref && withRef) {
            registerRef(item, ref);
        }
        return () => unregisterRef(item);
    }, [item, ref, withRef, registerRef, unregisterRef]);

    const cardType = type || itemType;
    const CardComponent = component || getComponentFromName(components || CardComponents, cardType);
    if (CardComponent === null && process.env.NODE_ENV === 'development') {
        // console.warn(`Missing card ${cardType}`, item); // eslint-disable-line
    }
    return (
        <div className={className} ref={withRef ? ref : null}>
            {CardComponent !== null ? (
                <CardComponent item={item} selected={selected} {...props} />
            ) : (
                cardType
            )}
        </div>
    );
};

Card.propTypes = propTypes;
Card.defaultProps = defaultProps;

export default Card;
